<div class="cure-sheet-list" *ngIf="sheets.length > 0">
  <span class="list-label">Cure sheets:</span>
  <button
    type="button"
    *ngFor="let sheet of sheets"
    class="sheet-link"
    [class.sheet-default]="isDefault(sheet)"
    [disabled]="pdfPending === pdfKey(sheet)"
    (click)="openPdf(sheet)"
    [title]="(sheet.meta?.productName || sheet.brandName) + ' v' + sheet.version + ' — ' + sheet.fileName"
  >
    {{ sheet.brandName }}
    <!-- The revision is shown, not just the product. Two operators reading "COR72"
         on different days may be looking at different documents, and which one they
         used is what a later report has to be able to state. -->
    <span class="sheet-version">v{{ sheet.version }}</span>
    <span class="default-badge" *ngIf="isDefault(sheet)">default</span>
  </button>
  <span class="sheet-error" *ngIf="pdfError">{{ pdfError }}</span>
</div>
